import { useMutation } from '@tanstack/react-query';
import { AuthApis } from './api';

const useLoginUser = ({ onSuccess, onError }) => {
  const mutationResult = useMutation({
    mutationFn: payload => AuthApis.login(payload),
    onSuccess,
    onError,
  });

  return mutationResult;
};

const useVerifyLoginOtp = ({ onSuccess, onError }) => {
  const mutationResult = useMutation({
    mutationFn: payload => AuthApis.verifyLoginOtp(payload),
    onSuccess,
    onError,
  });

  return mutationResult;
};

const useResendLoginOtp = ({ onSuccess, onError }) => {
  const mutationResult = useMutation({
    mutationFn: payload => AuthApis.resendLoginOtp(payload),
    onSuccess,
    onError,
  });

  return mutationResult;
};

const useLogoutUser = ({ onSuccess, onError }) => {
  const mutationResult = useMutation({
    mutationFn: () => AuthApis.logout(),
    onSuccess,
    onError,
  });

  return mutationResult;
};

export const AuthMutations = {
  useLoginUser,
  useVerifyLoginOtp,
  useResendLoginOtp,
  useLogoutUser,
};
